module.exports = __webpack_public_path__ + "media/images/country_flags/om-7094eddd459e269d4e4c5316ee775073.png";